
import Toast from 'vux/src/components/toast/index.vue'

import {mapGetters} from 'vuex'
export default{
components: {Toast},
created () {
},
methods: {},
data () {
return {}
},
computed: {
...mapGetters(['toast'])
}
}



// WEBPACK FOOTER //
// ./src/components/toast.vue